export default __webpack_public_path__ + "static/media/CNo.61-5.1f5377d9.jpg";